import { ReactComponentManifest } from "web/entrypoints/common/setup";
import FourXX from "web/react/pages/error/4xx/4xx";

const components: ReactComponentManifest = {
    FourXX,
};

export default components;
